export default "__VITE_PUBLIC_ASSET__bad8d31a__"